import React from 'react'
import { withTranslation } from 'react-i18next'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error Boundary caught an error:', error, errorInfo)
    this.setState({
      error,
      errorInfo
    })
  }

  render() {
    const { t } = this.props;

    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-neutral-50 to-primary-50 p-8">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl font-bold text-red-600 mb-4">{t('common:errors.somethingWentWrong')}</h1>
            <div className="bg-white rounded-2xl shadow-lg p-6">
              <p className="text-neutral-600 mb-4">
                {t('common:errors.applicationError')}
              </p>
              <details className="bg-red-50 p-4 rounded text-sm">
                <summary className="font-medium text-red-700 cursor-pointer">{t('common:errors.errorDetails')}</summary>
                <pre className="mt-2 text-red-600 whitespace-pre-wrap">
                  {this.state.error && this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </details>
              <button
                onClick={() => window.location.reload()}
                className="mt-4 bg-primary-500 text-white px-4 py-2 rounded-lg hover:bg-primary-600"
              >
                {t('common:actions.reloadApplication')}
              </button>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default withTranslation()(ErrorBoundary)
